export default __webpack_public_path__ + "static/plp--anejo--mobile-3927159fa921d50c639061747f076350.jpg";